export type ContentEnrollEnrolledLabel = 'unenroll' | 'enrolled';

export interface GetContentEnrollButtonLabelParams {
  isSpecial?: boolean;
  isEnrolled?: boolean;
  isSubscribed?: boolean;
  isIconic?: boolean;
  isIconicPro?: boolean;
  iconicExpired?: boolean;
  iconicProExpired?: boolean;
  plusExpired?: boolean;
  isIconicUser?: boolean;
  isIconicProUser?: boolean;
  isPlusUser?: boolean;
  ctaLabel?: string;
  enrolledStateLabel?: ContentEnrollEnrolledLabel;
}

const getEnrolledLabel = (enrolledStateLabel: ContentEnrollEnrolledLabel) =>
  enrolledStateLabel === 'enrolled' ? 'Enrolled' : 'Unenroll';

const getContentEnrollButtonLabel = ({
  isSpecial = false,
  isEnrolled = false,
  isSubscribed = false,
  isIconic = false,
  isIconicPro = false,
  iconicExpired = false,
  iconicProExpired = false,
  plusExpired = false,
  isIconicUser = false,
  isIconicProUser = false,
  isPlusUser = false,
  ctaLabel = 'Get subscription',
  enrolledStateLabel = 'unenroll'
}: GetContentEnrollButtonLabelParams): string => {
  if (isSpecial) {
    return isEnrolled ? getEnrolledLabel(enrolledStateLabel) : 'Enroll';
  }

  if (isSubscribed && isEnrolled) {
    return getEnrolledLabel(enrolledStateLabel);
  }

  if (isSubscribed) {
    return 'Enroll';
  }

  if (iconicProExpired && isIconicPro) {
    return 'Renew subscription';
  }

  if (iconicExpired && isIconic) {
    return 'Renew subscription';
  }

  if (
    (plusExpired && isIconicPro && !isIconicProUser) ||
    (isIconicPro && (isPlusUser || isIconicUser) && !isIconicProUser)
  ) {
    return 'Get Iconic Pro plan';
  }

  if (
    (plusExpired && isIconic && !isIconicUser && !isIconicProUser) ||
    (isIconic && isPlusUser && !isIconicUser && !isIconicProUser)
  ) {
    return 'Get Iconic plan';
  }

  if (plusExpired) {
    return 'Renew subscription';
  }

  if (isIconicPro) {
    return 'Get Iconic Pro plan';
  }

  if (isIconic) {
    return 'Get Iconic plan';
  }

  return ctaLabel;
};

export default getContentEnrollButtonLabel;
